import { render, staticRenderFns } from "./StockPlaceMoldLocationDialog.vue?vue&type=template&id=dff96bb4&"
import script from "./StockPlaceMoldLocationDialog.vue?vue&type=script&lang=js&"
export * from "./StockPlaceMoldLocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports